import { render, staticRenderFns } from "./exercisePlan.vue?vue&type=template&id=138cf988&scoped=true&"
import script from "./exercisePlan.vue?vue&type=script&lang=js&"
export * from "./exercisePlan.vue?vue&type=script&lang=js&"
import style0 from "./exercisePlan.vue?vue&type=style&index=0&id=138cf988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138cf988",
  null
  
)

export default component.exports